import createRecaptcha from './recaptchaWrapper';
let recaptchaLoaded = false;
let codeBase = 0;
export default {
  name: 'VueRecaptcha',
  props: {
    isHcaptcha: {
      type: Boolean,
      default: false
    },
    isCn: {
      type: Boolean,
      default: false
    },
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    recaptchaScriptId: {
      type: String,
      default: '__RECAPTCHA_SCRIPT'
    },
    language: {
      type: String,
      default: ''
    },
    isGrecaptchaEnt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    captchaHost() {
      if (this.isHcaptcha) return '//hcaptcha.com/1';
      if (this.isCn) return 'www.recaptcha.net/recaptcha';
      return 'www.google.com/recaptcha';
    }
  },
  beforeMount() {
    this.recaptcha = createRecaptcha(this.isGrecaptchaEnt);
    if (window.grecaptcha) {
      if (!recaptchaLoaded) {
        recaptchaLoaded = true;
        this.recaptcha.notify();
      }
    } else {
      const callbackName = 'vueRecaptchaApiLoaded_' + codeBase++;
      window[callbackName] = this.recaptcha.notify;
      recaptchaLoaded = true;
      // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
      const script = document.createElement('script');
      script.id = this.recaptchaScriptId;
      // hcaptcha.com/1/api.js?hl=
      // www.google.com/recaptcha/api.js?hl=
      const path = (!this.isHcaptcha && this.isGrecaptchaEnt) ? '/enterprise.js' : '/api.js';
      script.src = `https://${
        this.captchaHost
      }${path}?onload=${callbackName}&render=explicit&hl=${
        this.language
      }`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  },
  mounted() {
    this.recaptcha.checkRecaptchaLoad();
    const opts = {
      ...this.$props,
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    };
    const container = this.$slots.default ? this.$el.children[0] : this.$el;
    this.recaptcha.render(container, opts, id => {
      this.$widgetId = id;
      this.$emit('render', id);
    });
  },
  methods: {
    reset() {
      this.recaptcha.reset(this.$widgetId);
    },
    execute() {
      this.recaptcha.execute(this.$widgetId);
    },
    emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired() {
      this.$emit('expired');
    },
    emitError(error) {
      this.$emit('error', error);
    }
  },
  render(h) {
    return h('div', {}, this.$slots.default);
  }
};
